import WithDifference from './component'

export default WithDifference
